import resourcesApi from "@/api/resources/resourcesApi";
import store from "@/store";
import CriticalAppErrorComponent from "@/components/modules/global/criticalAppError/CriticalAppErrorComponent";
import GettingDataOverlayComponent
    from "@/components/modules/global/gettingDataOverlayComponent/GettingDataOverlayComponent";
import ClosingChecklistListComponent from "@/components/modules/ClosingChecklists/ClosingChecklistListComponent";

export const CLOSING_CHECKLIST_DATA_KEY = "closing_checklist";
export const CLOSING_CHECKLIST_QUESTIONS_DATA_KEY = "question_data";


export default {
    components : {
        critErr: CriticalAppErrorComponent,
        gettingDataOverlay: GettingDataOverlayComponent,
        CclComponent : ClosingChecklistListComponent
    },
    data: () => {
        return {
            is_loading : false,
            closingChecklistKey : null,
            hasCriticalError : false,
            errorMessage : "Unknown loading error",
            requiresClosingChecklist : false,
            loadClosingChecklistDataFailed : false,
            loadClosingChecklistError : null,
            closingChecklistFormData : []
        }
    },
    methods : {
        /* CLOSING CHECKLIST FORM PART */
        async checkComponentRequiresClosingChecklist(){
            let ws = await store.getters.getActiveWorkSession;
            if(ws && (ws.project_settings != null &&  (ws.project_settings.closing_checklist_key != undefined && ws.project_settings.closing_checklist_key != null))){
                this.closingChecklistKey = ws.project_settings.closing_checklist_key;
                this.requiresClosingChecklist = true
                return true
            }
            this.is_loading = false;
            return false
        },

        async downloadClosingChecklistData($listKey){
            this.loadCustomLmraDataFailed = false;
            this.loadCustomLmraError = null;

            let dataResponse = await resourcesApi.getClosingChecklistData($listKey)
                .then(response => {
                    return response
                })
                .catch((error) => {
                    this.loadClosingChecklistDataFailed = true;
                    this.loadClosingChecklistError = error;
                });
            return dataResponse;
        },
        async initializeClosingChecklistData(){
            let validatedData = await this.getAndValidateClosingChecklistDataFromServer();
            if(validatedData !== null){
               await this.buildClosingChecklist(validatedData);
            }
        },
        async getAndValidateClosingChecklistDataFromServer(){
            let validatedData = null;
            let closingChecklistResponseData = await this.downloadClosingChecklistData(this.closingChecklistKey);


            if(this.loadClosingChecklistDataFailed){

                if (this.loadClosingChecklistError.response.data !== undefined &&
                    this.loadClosingChecklistError.response.data !== null &&
                    this.loadClosingChecklistError.response.data.status !== undefined)
                {
                    this.triggerCriticalLoadingError(this.loadClosingChecklistError.response.data.status);
                }

            }
            if(
                (
                    closingChecklistResponseData !== null &&
                    closingChecklistResponseData.data !== undefined &&
                    closingChecklistResponseData.data !== null
                )
            ) {
                if(
                    closingChecklistResponseData.data.key === undefined &&
                    closingChecklistResponseData.data.key !== this.closingChecklistKey
                ){
                    this.triggerCriticalLoadingError('CLOSING KEYS DO NOT MATCH!')
                }

                if(
                    closingChecklistResponseData.data.closing_checklist_questions === undefined &&
                    closingChecklistResponseData.data.closing_checklist_questions === null
                ){
                    this.triggerCriticalLoadingError('FORMDATA MISSING OR CORRUPT!')
                }

               validatedData = closingChecklistResponseData.data;

            }else{
                this.triggerCriticalLoadingError('Error: Response does not contain data ...');
            }

            return validatedData;
        },
        async buildClosingChecklist(data){
            for(const item of data.closing_checklist_questions){
                let newQuestion = {
                    type : item.type,
                    key : item.key,
                    question : item.default,
                }

                if(item.translation !== undefined && item.translation !== null){
                    newQuestion.question = item.translation;
                }

                switch (item.type){
                    case "OPEN-QUESTION":
                        newQuestion.answer = ""
                        break;
                    case "THREE-STATE":
                    case "TWO-STATE":
                        newQuestion.current_state = -1
                        break;
                }
                this.closingChecklistFormData.push(newQuestion);
            }

            this.is_loading = false;

        },
        async getClosingChecklistDataForDataTransfer(){
            var formattedClosingChecklistData = {};
            var question_data = {};

            for(const item of this.closingChecklistFormData){
                var $answer = null
                switch (item.type){
                    case "OPEN-QUESTION":
                        $answer = item.answer
                        break;
                    case "THREE-STATE":
                    case "TWO-STATE":
                        $answer = item.current_state
                        break;
                }
                question_data[item.key] = $answer;
            }

            formattedClosingChecklistData['key'] = this.closingChecklistKey;
            formattedClosingChecklistData[CLOSING_CHECKLIST_QUESTIONS_DATA_KEY] = question_data
            return formattedClosingChecklistData;
        },
        allQuestionsAnsweredCorrectly(){
            return false;
        },
        triggerCriticalLoadingError($message){
            this.errorMessage = $message;
            this.hasCriticalError = true;
            this.is_loading = false;
        },

        /* END CLOSING CHECKLIST FORM PART */
    },
    async mounted() {
        this.is_loading = true
        //window.console.log('Checking CLL Required ....');
        if(await this.checkComponentRequiresClosingChecklist()){
            //window.console.log('LOADING ....');
             await this.initializeClosingChecklistData();
        }
    },
    computed : {
        isFilled: function () {
            return this.allQuestionsAnsweredCorrectly();
        }
    }
}